import { Controller } from "@hotwired/stimulus"
import { holdKeyboardUntilNextPage } from "../utils/keyboard_relay"

// Champ de recherche de l'en-tête (Shared::SearchBarComponent, variante inline) : sur téléphone,
// le toucher ouvre la page de recherche au lieu de déplier les résultats sous le champ, clavier
// ouvert sur son champ. Sur un grand écran, rien ne change. L'onglet Rechercher de la barre du bas
// (MobileNavbarComponent) garde lui aussi le clavier (`holdKeyboard`).
const PHONE = "(max-width: 991.98px)"

export default class extends Controller {
  static values = { url: String }

  // Au `focus` : le toucher du champ a ouvert le clavier, que le relais garde pendant la visite.
  open() {
    if (!this.urlValue || !window.matchMedia(PHONE).matches || this.opening) return

    this.opening = true
    holdKeyboardUntilNextPage()
    window.Turbo ? window.Turbo.visit(this.urlValue) : window.location.assign(this.urlValue)
  }

  holdKeyboard() {
    holdKeyboardUntilNextPage()
  }

  disconnect() {
    this.opening = false
  }
}
